export const STRIPE_KEY = () => window.STRIPE_KEY || 'pk_test_3M9DzhnVIuUxBP77iAMRe4DN00CcNiHrJK'